// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__CBxw6","smallPadding":"Faq_smallPadding__vYkj1","heading":"Faq_heading__jfudB"};